import { useState, useCallback } from 'react';
import { checkSpelling } from '../services/spellCheckService';

const useSpellCheck = () => {
    const [errors, setErrors] = useState([]);
    const [lastCheckedText, setLastCheckedText] = useState('');
    const [isChecking, setIsChecking] = useState(false);

    const check = useCallback(async (text) => {
        if (!text.trim() || text === lastCheckedText) return;

        setIsChecking(true);
        try {
            const errors = await checkSpelling(text);
            setErrors(errors);
            setLastCheckedText(text);
            return errors;
        } catch (error) {
            console.error('Ошибка проверки орфографии:', error);
            throw error;
        } finally {
            setIsChecking(false);
        }
    }, [lastCheckedText]);

    return { errors, check, isChecking, lastCheckedText };
};

export default useSpellCheck;